import React from 'react';

class Footer extends React.Component{
    render(){
        return(
            <div>
                <div className="toast-notification-container">
                    <div className="toast-notification">
                        <div className="notification-message">
                            <p></p>
                        </div>
                        <div className="notification-icon">
                            <img src="http://showcaseadmin.iimjobs.com/static/images/close-icon-white.png" />
                        </div>
                    </div>
                </div>
                <section className="footer">
                    <div className="footer-copy-text">
                        <p> iimjobs.com © {new Date().getFullYear()}. All rights reserved.</p>
                    </div>
                </section>
            </div>
        );
    }
}

export default Footer